<script setup lang="ts">
import { useI18n } from "vue-i18n"
import { watch } from "vue"
import { useRoute } from "vue-router"

import { useIrveStore } from "@modules/irve/stores/irve.store"
import { storeToRefs } from "pinia"
import { useBuildingStore } from "@core/stores/building-v2.store"

const { t } = useI18n({
    messages: {
        fr: {
            title: "Simulation IRVE",
        },
    },
})

const irveStore = useIrveStore()

const buildingStore = useBuildingStore()

const { isFetchingBuilding } = storeToRefs(buildingStore)

const route = useRoute()

/**
 * Reset du store IRVE au changement de bâtiment via navigation SPA
 * (DEV-381, parent DEV-378). Sans ce watcher, `currentAnalysisId` hérite
 * du bâtiment précédent et `IrveView` peut afficher une analyse qui
 * n'appartient plus au bâtiment courant.
 */
watch(
    () => route.params._id_building,
    (newBid, prevBid) => {
        if (!prevBid || !newBid || prevBid === newBid) return
        irveStore.$reset()
        void irveStore.fetchAnalyses.fetch()
    }
)
</script>

<template>
    <LoadingApp v-if="isFetchingBuilding" class="page"></LoadingApp>
    <div class="page-residual-power page flex flex-col gap-8" v-else>
        <HeaderPageBuilding :title="t('title')"></HeaderPageBuilding>
        <!-- Formulaire -->
        <IrveForm />
        <!-- Visualiser l'analyse -->
        <IrveView
            id="irve-view"
            v-if="
                !irveStore.fetchAnalyses.isFetching &&
                irveStore.analyses?.length
            "
        />
        <!-- Historique des analyses -->
        <IrveHistory />
    </div>
</template>
